










import { Component, Prop, Vue } from 'vue-property-decorator';
import Overlay from '@/components/atoms/Overlay.vue';
import NewcrossLoader from '@/components/atoms/NewcrossLoader.vue';

@Component({
  components: {
    Overlay,
    NewcrossLoader,
  },
})
export default class LoadingOverlay extends Vue {
  @Prop() private text!: string | boolean;
}
